<template>
  <div class="home-container" style="height: 100%">
    <MenuComponent />
    <HeaderComponent />
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderComponent from "../components/HeaderComponent.vue";
import MenuComponent from "../components/MenuComponent.vue";

export default defineComponent({
  name: "HomeView",
  components: {
    HeaderComponent,
    MenuComponent,
  },
});
</script>

<style scoped>
.home-container {
  display: flex;
}

.main-content {
  margin-left: 230px;
  margin-top: 60px;
  padding: 20px;
  width: calc(100% - 230px);
  background-color: #f5f7fa;
}
</style>
